import { StateSchema } from 'app/config/storeConfig/types';
import { SizeFilter } from '../types';

export const getSelectedFilter = (state: StateSchema): SizeFilter => state.boxSizeFilter.selectedFilter;
